/*
**  rui-record-detail.js
**
**  rui-record-detail component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
export class RuiRecordDetail extends LitElement {
    static get is() {
        return 'rui-record-detail';
    }
    static get properties() {
        return {
            width: { type: String }
        };
    }
    constructor() {
        super();
        this._width = 'medium';
    }
    set width(value) {
        this._width = value;
        // Pass the record detail width on to each record detail block
        this.updateBlockWidths();
        // Re-render
        this.requestUpdate();
    }
    get width() {
        return this._width;
    }
    connectedCallback() {
        super.connectedCallback();
        // Pass the record detail width on to each record detail block
        this.updateBlockWidths();
    }
    // Pass the record detail width on to each record detail block
    updateBlockWidths() {
        for (let i = 0; i < this.children.length; i++) {
            const tagName = this.children[i].tagName.toLowerCase();
            if (tagName === 'rui-record-detail-block') {
                this.children[i]._width = this.width;
            }
            else if (tagName === 'jha-record-detail-block') {
                this.children[i].jhaWidth = this.width; // Angular wrapper
            }
        }
    }
    render() {
        const classes = {
            ['rui-record-detail']: true,
            ['rui-record-detail-full']: this.width.toLowerCase() === 'full'
        };
        return html `
            <div class="${classMap(classes)}">
                <slot></slot>
            </div>
        `;
    }
    static get styles() {
        return css `
            :host {
                display: block;
            }
            
            .rui-record-detail {
                display: flex;
                flex-wrap: wrap;
            }
            
            .rui-record-detail-full {
                display: block;
            }
            
            @media only screen and (max-width: 600px) {
                .rui-record-detail {
                    flex-direction: column;
                }
            }
        `;
    }
}
customElements.get(RuiRecordDetail.is) || customElements.define(RuiRecordDetail.is, RuiRecordDetail);
